import React from 'react';
import { Box, Typography, Chip, IconButton, Tooltip, Divider } from '@mui/material';
import CustomButton from '../../Button/customButton/CustomButton';
import styles from '../../../styles/table/index.module.scss';
import { getIconCoverClassName } from '../../../utils/commonfunctions';
const DataGridContainer = ({
  name,
  headerActionButtons = [],
  headerContent,
  isHeaderContentVisible,
  children,
  showTitleTooltip = false,
  headerContentRight = null,
}) => {
  const leftButtons = headerActionButtons.filter(btn => !btn.section || btn.section === 'left');
  const rightButtons = headerActionButtons.filter(btn => btn.section === 'right');

  return (
    <Box
      className={styles.container}
    >
    {isHeaderContentVisible && 
      <Box className={styles.containerHeader}>
        <Box className={styles.summaryInfo}>
          <Tooltip title={showTitleTooltip ? name : ""}>
            <Typography
              variant="componentTitle"
              className={'secondary ellipsis-container-line-2'}
            >
              {name || 'Test Case Library'}
            </Typography>
          </Tooltip>

          {headerContent && (
            <Box className={`bg-slate100 slate700 ${styles.headerContent}`}>
              {headerContent()}
            </Box>
          )}
        </Box>
        
        <Box className={`${styles.headerContentRight} bg-slate50`}>
          {headerContentRight && (
            <Box sx={{ mr: 1 }}>
              {headerContentRight()}
            </Box>
          )}
          {leftButtons.map((button, idx) => {
            if (button.fullbutton) {
              return (
                <CustomButton
                  key={idx}
                  variant="contained"
                  startIcon={button.icon}
                  onClick={button.action}
                  disabled={button.disabled}
                  sx={{ minWidth: 120, fontWeight: 600, fontSize: '0.95rem', height: '40px', px: 2, py: 1 }}
                >
                  {button.name}
                </CustomButton>
              );
            }
            const isContained = button.contained !== undefined ? button.contained : true;
            const isDisabled = button.disabled || false;
            const className = getIconCoverClassName(isDisabled ? 'disabled' : (isContained ? button.name : 'not-contained'));

            return (
              <Tooltip key={idx} title={button.tooltip}>
                <Box
                  onClick={!isDisabled ? button.action : undefined}
                  role="button"
                  className={`icon-cover ${className}`}
                  disabled={isDisabled}
                  disableRipple
                  sx={{
                    boxShadow: isDisabled || !isContained  ? 'none'  : '0 1px 2px 0 rgb(16 112 255 / 0.06)',
                  }}
                >
                    {button.icon}
                </Box>
              </Tooltip>
            );
          })}
          {rightButtons.length > 0 && leftButtons.length > 0 && (
            <Divider orientation="vertical" flexItem className={`${leftButtons.length > 1 ? styles.divider : styles.divider2}`}/>
          )}
          {rightButtons.map((button, idx) => {
            if (button.fullbutton) {
              return (
                <CustomButton
                  key={idx}
                  variant="contained"
                  startIcon={button.icon}
                  onClick={button.action}
                  disabled={button.disabled}
                  sx={{ minWidth: 120, fontWeight: 600, fontSize: '0.95rem', height: '40px', px: 2, py: 1 }}
                >
                  {button.name}
                </CustomButton>
              );
            }
            const isDisabled = button.disabled || false;
            return (
              <Tooltip key={idx} title={button.tooltip}>
                <Box
                  onClick={!isDisabled ? button.action : undefined}
                  role="button"
                  className={`icon-cover not-contained ${isDisabled ? 'cursor-not-allowed box-shadow-none' : ''}`}
                  sx={{
                    boxShadow: '0 1px 2px 0 rgb(16 112 255 / 0.06)',
                  }}
                >
                  {button.icon}
                </Box>
              </Tooltip>
            );
          })}
        </Box>
      </Box> }
      <Box 
        sx={{
          flexGrow: 1,
          overflow: 'auto',
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default DataGridContainer;